module.exports = __webpack_public_path__ + "static/img/record_local2.1d3482f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/record_local2.png
// module id = 923
// module chunks = 1